<template lang="pug">
.container
  img.drag-img(v-bind="dropImgBind", v-if="dragging_stamp")
  .header
    .el-dialog__title(style="height: 30px") {{ title }}
    div
      slot(name="header")
        component(v-if="headerSlot", :is="headerSlot")
  .modal
    .toasts(v-if="toastText", :key="toastText") {{ toastText }}
  .midder(tabIndex="0")
    .main(@click.right.prevent, ref="main", @wheel.ctrl.prevent="onWheel")
      .center(v-bind="mainBind", v-on="mainOn", ref="content")
        canvas(ref="canvas")
    .right(v-if="pdf", @click.right.prevent)
      el-tabs(v-model="tabIndex", stretch="stretch")
        el-tab-pane(label="签章", name="1")
          ul.stamp-list
            li(v-for="s in stampList", :key="s.id", @mousedown="dragStart($event, s)")
              img.stamp-img(:alt="s.label", draggable="false", :src="s.base64")
              span {{ s.label }}
        el-tab-pane(label="页面", name="2")
          ul.pdf-stamp-list
            li(v-for="s in pageStampsInfoList", :class="{ active: s.active }", :key="s.id", @click="activeStamp(s)")
              img.delete(src="./close.png", @click.stop="deleteStamp(s)")
              img.bg(:src="s.base64")
              div 类型 : {{ s.label }}
              div 宽 : {{ ~~s.width }}
              div 高 : {{ ~~s.height }}
              div 上 : {{ ~~s.top }}
              div 左 : {{ ~~s.left }}
  .footer
    el-pagination(:current-page="pageIndex", layout="prev, pager, next, jumper", :page-size="1", size="small", :total="pageTotal", @current-change="getPage")
    slot(name="footer", :pdf="pdf")
      el-button(size="small", type="primary", @click="handleSubmit()") {{ confirmText }}
      el-button(size="small", @click="close()") 取消
</template>
<script>
import { fabric } from "fabric";
import { clamp, round, throttle } from "lodash-es";
import delIcon from "./close.png";
import { loadImage, img2base64 } from "@/CommonDP/utils/methods";
import { importScript } from "@/CommonDP/utils";
import { asyncMixin } from "@/CommonDP/commons/asyncCom";
const pdfScript = importScript({ src: "./stamp-pdf.mjs", type: "module" });
const img = document.createElement("img");
img.src = delIcon;
let sId = 1;
export default {
  mixins: [asyncMixin],
  props: {
    resize: { default: true, type: Boolean },
    // 传入上方title后插槽
    headerNode: {
      type: Function,
      default: undefined
    },
    // 获取签章的列表
    queryStamp: {
      type: Function,
      default: () => []
    },
    // 获取pdf的接口
    getPdf: {
      type: Function,
      default: () => undefined
    },
    onPageUpdate: {
      type: Function,
      default: new Function()
    },
    // 提交时方法数据
    onSubmit: {
      type: [Function, undefined],
      default: undefined
    },
    // 获取之前的旧数据 需要返回json字符串
    getCache: {
      type: [Function, undefined],
      default: undefined
    },
    title: { type: String, default: "" },
    confirmText: { type: String, default: "保存" }

  },
  data() {
    return {
      toastText: "",
      pdf: undefined,
      stage: undefined,
      show: true,
      width: 500,
      height: 500,
      scale: 1,
      sizes: [],
      pageIndex: 1,
      tabIndex: "1",
      tabs: [
        { id: "1", cnName: "签章" },
        { id: "2", cnName: "页面" }
      ],
      pageTotal: 0,
      pdfStamps: [],
      stampList: [],
      activeStampId: [],
      //! 注意!
      //!  cachePdfStamp 缓存回显时的数据
      //! 将在加载对应页面时将数据重新计算后放到实际数据中去,并且将对应的缓存数据处理掉
      cachePdfStamp: [],
      headerSlot: undefined,
      // 拖动数据
      drop: {
        id: undefined,
        width: 0, // 拖动时实时宽度
        fromWidth: 0, // 拖动前宽度
        toWidth: 0, // 拖动最终宽度
        offsetX: 0, // 拖动时偏移坐标
        offsetY: 0,
        x: 0, // 拖动时实时坐标
        y: 0,
        fromX: 0, // 拖动前坐标
        fromY: 0,
        progress: 0, // 渐变进度
        on: false // 是否在画布之上
      }
    };
  },
  computed: {
    // 已经格式化过的签章数据
    sealList() {
      const { pdfStamps, cachePdfStamp, stamp2data } = this;
      const list = [];
      // 将未加载过的缓存加载到数据中 (已经去掉展示的数据了)
      list.push(...cachePdfStamp);
      for (let i = 0; i < pdfStamps.length; i++) {
        const pdfPage = pdfStamps[i] || [];
        for (const stamp of pdfPage) {
          const data = stamp2data(stamp, i + 1);
          list.push(data);
        }
      }
      return list;
    },
    // 当前展示页的已签章
    pageStamps() {
      const { pdfStamps, pageIndex } = this;
      return pdfStamps[pageIndex - 1];
    },
    pageStampsInfoList() {
      const list = [];
      const map = {};
      const { stampList, pageStamps, activeStampId } = this;
      if (!pageStamps) return [];
      for (const s of stampList) {
        map[s.id] = s;
      }
      for (const s of pageStamps) {
        const info = map[s.stampId];
        if (info) {
          list.push({
            ...info,
            ...s,
            active: activeStampId.indexOf(s.id) !== -1
          });
        }
      }
      return list;
    },
    mainBind() {
      const {
        drop: { on, id }
      } = this;
      const className = { focus: id && !on };
      return { class: className };
    },
    mainOn() {
      const {
        drop: { on },
        dropStamp
      } = this;
      const listener = {};
      if (on) listener.mouseup = dropStamp;
      return listener;
    },
    dragging_stamp() {
      const {
        stampList,
        drop: { id }
      } = this;
      const stamp = stampList.find((stamp) => id === stamp.id);
      return stamp;
    },
    dropImgBind() {
      const {
        dragging_stamp: stamp,
        drop: { x, y, offsetX, offsetY, width }
      } = this;
      return stamp
        ? {
          src: stamp.base64,
          style: {
            transform: `translate(${x - offsetX}px,${y - offsetY}px)`,
            width: width + "px"
          }
        }
        : undefined;
    }
  },
  async mounted() {
    await pdfScript;
    sId = 1;
    this.initSlot();
    await this.updateVm();
    this.bindScaleKeyBind();
  },
  methods: {
    // 缩放绑定键盘事件
    bindScaleKeyBind() {
      const { ctrlKeyPressHandle } = this;
      document.addEventListener("keydown", ctrlKeyPressHandle);
      this.$on("hook:destroyed", () => {
        document.removeEventListener("keydown", ctrlKeyPressHandle);
      });
    },
    ctrlKeyPressHandle(e) {
      const { scale, stage } = this;
      if (!stage && e.ctrlKey) return;
      let isProxy = true;
      switch (e.key) {
        case "+":
        case "=":
          this.throttleScale(scale + 0.1);
          break;
        case "-":
          this.throttleScale(scale - 0.1);
          break;
        case "0":
          this.throttleScale(1);
          break;
        default:
          isProxy = false;
          break;
      }
      if (isProxy) {
        e.preventDefault();
      }
    },
    // 将传来的vnode,转换为组件后引用
    initSlot() {
      const { headerNode } = this;
      if (headerNode) {
        this.headerSlot = {
          render: (h) => headerNode(this, h)
        };
      }
    },
    async updateVm() {
      this.stampList = [];
      this.pdfStamps = [];
      this.sizes = [];
      this.width = 500;
      this.height = 500;
      await this.loadPdf();
      this.initStage();
      await this.renderPage();
      await this.initStampList();
      await this.initCache();
      await this.renderPageStamp();
    },
    // 滚轮事件
    onWheel(e) {
      const { scale } = this;
      const k = e.deltaY > 0 ? -0.1 : 0.1;
      this.throttleScale(scale + k);
    },
    throttleScale: throttle(function (...arg) {
      this.changeScale(...arg);
    }, 90),
    changeScale(value = 1) {
      const { scale, width, height } = this;
      // 灰色窗口大小
      const { width: mainW, height: mainH } = this.$refs.main.getBoundingClientRect();
      const dh = (mainH - 24) / height;
      const dw = mainW / width;
      const maxScale = Math.max(1, dh, dw);
      const minScale = Math.min(1, dh, dw);
      const nextScale = round(clamp(value, minScale, maxScale), 2);
      if (nextScale !== scale) {
        this.scale = nextScale;
        this.willReSize();
      }
    },
    willReSize() {
      this.toastText = `${round(this.scale * 100)}%`;
      if (!this.stage) return;
      this.throttleRender();
    },
    // 事件触发过于频繁,会导致签章异常,添加节流,减少更新频率
    throttleRender: throttle(function () {
      const { scale } = this;
      return this.renderPage().then(() => scale === this.scale && this.renderPageStamp());
    }, 300),
    async initCache() {
      const { stampList } = this;
      const str = await this.getCache?.(this);
      const cache = [];
      if (str) {
        const list = JSON.parse(str);
        for (const stamp of list) {
          const hasStampId = stampList.find(({ id }) => stamp.imageFileId === id);
          // 剔除不存在的图章
          if (hasStampId) cache.push(stamp);
        }
      }
      this.cachePdfStamp = cache;
    },
    async initStampList() {
      const list = await this.queryStamp(this);
      const waitList = [];
      for (const stamp of list) waitList.push(this.initStampImage(stamp));
      await Promise.all(waitList);
      this.stampList = list || [];
    },
    async initStampImage(stamp) {
      const img = await loadImage(stamp.src);
      stamp.defaultWidth = img.width;
      stamp.defaultHeight = img.height;
      stamp.base64 = img2base64(img);
    },
    async handleSubmit(withCert) {
      const { onSubmit, sealList } = this;
      if (onSubmit) {
        await onSubmit(sealList, this, withCert);
      }
      this.resolve(sealList);
      this.close();
    },
    close() {
      this.show = false;
      this.reject();
    },
    getTestPdf() {
      return fetch("/response.pdf").then((res) => res.arrayBuffer());
    },
    async loadPdf() {
      const data = await this.getPdf(this);
      const loadingTask = pdfjsLib.getDocument({
        data,
        useSystemFonts: true,
        cMapUrl: "/pdf/web/cmaps/",
        cMapPacked: true
      });
      const pdf = await loadingTask.promise;
      this.pageTotal = pdf.numPages;
      this.pdf = pdf;
      this.$on("hook:beforeDestroy", () => {
        loadingTask.destroy();
      });
    },
    initStage() {
      const isUpdate = !!this.stage;
      const stage = isUpdate
        ? this.stage
        : new fabric.Canvas(this.$refs.canvas, {
          hoverCursor: "pointer",
          selection: false
        });
      stage.clear();
      const text = new fabric.Text("正在加载...", { evented: false });
      if (!isUpdate) {
        stage.add(text);
        stage.on("selection:cleared", this.activeStampHandler);
        stage.on("selection:updated", this.activeStampHandler);
        stage.on("selection:created", this.activeStampHandler);
        stage.on("drop", this.dropStamp);
        this.stage = stage;
      }
    },
    // 创建pdf页面
    async renderPdf(page) {
      const { stage, pageIndex, sizes, scale } = this;
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      const viewport = page.getViewport({ scale: scale });
      // 实际视图的宽高
      const width = ~~viewport.width;
      const height = ~~viewport.height;
      canvas.width = width;
      canvas.height = height;
      stage.setWidth(width);
      stage.setHeight(height);
      // 逻辑宽高
      const baseWidth = ~~(viewport.width / scale);
      const baseHeight = ~~(viewport.height / scale);
      this.width = baseWidth;
      this.height = baseHeight;
      this.$set(sizes, pageIndex, { width: baseWidth, height: baseHeight });
      // 渲染
      await page.render({
        canvasContext: context,
        viewport: viewport
      }).promise;
      return canvas;
    },
    // 绘制当前页的pdf pdf和签章
    async getPage(index = 1) {
      this.pageIndex = index;
      await this.renderPage();
      await this.renderPageStamp();
    },
    async renderPage() {
      const { stage, pageIndex: index } = this;
      const { pdf } = this;
      stage.clear().renderAll();
      stage.setBackgroundColor("#fff");
      const page = await pdf.getPage(index);
      const canvas = await this.renderPdf(page);
      const pageImg = new fabric.Image(canvas);
      stage.setBackgroundImage(pageImg);
      await this.onPageUpdate(this);
      stage.renderAll();
    },
    // 绘制当前页的签章
    async renderPageStamp() {
      const { stampList, stage, pdfStamps, cachePdfStamp, cache2Stamp } = this;
      const pageIndex = this.pageIndex - 1;
      const pageStamp = pdfStamps[pageIndex] || [];
      // 将缓存数据与图章数据合并
      const cachePage = cachePdfStamp.filter((item) => item.pageIndex === this.pageIndex); // 当前页的缓存
      for (const item of cachePage) {
        const index = cachePdfStamp.indexOf(item);
        const stamp = cache2Stamp(item);
        const { imageFileId } = item;
        const s = stampList.find(({ id }) => id === imageFileId);
        this.addStamp(s, stamp);
        cachePdfStamp.splice(index, 1);
      }
      // 绘制签章
      for (const item of pageStamp) {
        const s = stampList.find(({ id }) => id === item.stampId);
        const img = await this.initStamp(s, item);
        stage.add(img);
      }
      this.$set(this.pdfStamps, this.pageIndex - 1, pageStamp);
    },
    // 缓存转签章数据
    cache2Stamp({ imageFileId, imageHeight, imageWidth, locationX, locationY }) {
      const { width, height } = this;
      return {
        stampId: imageFileId,
        width: width * imageWidth,
        left: locationX * width,
        top: height - (locationY + imageHeight) * width
      };
    },
    // 签章数据转提交数据
    stamp2data({ stampId: imageFileId, top, left, width, height }, pageIndex = 1) {
      const { sizes } = this;
      const { width: pageWidth, height: size_h } = sizes[pageIndex];
      const size = pageWidth;
      const imageWidth = width / size;
      const imageHeight = height / size;
      const locationX = left / size;
      const locationY = (size_h - top - height) / size;
      return {
        imageFileId,
        locationX,
        locationY,
        imageHeight,
        imageWidth,
        pageIndex
      };
    },
    // 添加章
    async addStamp(s, obj) {
      const { stage } = this;
      const newStamp = { top: 0, left: 0, id: sId++, stampId: s.id, ...obj };
      const img = await this.initStamp(s, newStamp);
      stage.add(img);
      this.computedStamp(newStamp, img);
      this.pageStamps.push(newStamp);
    },
    // stage签章更新触发事件
    activeStampHandler(e) {
      const { selected } = e;
      this.activeStampId = selected ? selected.map(({ sId }) => sId) : [];
    },
    // 将图章绘制到 stage
    initStamp(s, item) {
      return new Promise((resolve, reject) => {
        const { resize, scale } = this;
        const { br, bl, tl } = fabric.Image.prototype.controls; // 图片控制器原型
        // 删除按钮
        const deleteControl = new fabric.Control({
          x: 0.5,
          y: -0.5,
          cornerSize: 18,
          cursorStyle: "pointer",
          mouseUpHandler: (_e, transform) => {
            const target = transform.target;
            const { canvas, sId } = target;
            const { pageStamps } = this;
            if (sId) {
              const index = pageStamps.findIndex(({ id }) => id === sId);
              if (index !== -1) pageStamps.splice(index, 1);
            }
            canvas.remove(target);
            canvas.requestRenderAll();
          },
          render(ctx, left, top, fabricObject) {
            const size = this.cornerSize;
            ctx.save();
            ctx.translate(left, top);
            ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
            ctx.drawImage(img, -size / 2, -size / 2, size, size);
            ctx.restore();
          }
        });
        // 控制器
        const controls = { deleteControl };
        const option = {
          borderColor: "#000",
          cornerSize: 8,
          transparentCorners: false,
          cornerColor: "#000",
          lockScalingFlip: true,
          lockRotation: true,
          hasRotatingPoint: false,
          controls
        };
        const onLoad = (img) => {
          img.on("modified", this.onStamp);
          img.sId = item.id;
          const { width, top = 0, left = 0 } = item;
          const opt = { left: left * scale, top: top * scale };
          if (width) img.scale((scale * width) / img.width);
          img.set(opt);
          resolve(img);
        };
        if (resize) {
          controls.br = br;
          controls.bl = bl;
          controls.tl = tl;
        }
        if (s) fabric.Image.fromURL(s.base64, onLoad, option);
        else reject();
      });
    },
    // 将stage的章坐标大小同步到this
    computedStamp(s, target) {
      const { scale } = this;
      const { left, height, top, width, scaleX } = target;
      s.left = left / scale;
      s.top = top / scale;
      s.width = (width * scaleX) / scale;
      s.height = (height * scaleX) / scale;
      return s;
    },
    // stage上章初次加载时触发
    onStamp({ target }) {
      const s = this.pageStamps.find(({ id }) => id === target.sId);
      s && this.computedStamp(s, target);
    },
    // 获取stage中的章
    getStampItem(s) {
      const { stage } = this;
      const list = stage.getObjects();
      return list.find(({ sId }) => sId === s.id);
    },
    // 高亮stage的章
    activeStamp(s) {
      const { stage } = this;
      const item = this.getStampItem(s);
      stage.discardActiveObject();
      if (item) {
        stage.setActiveObject(item);
        stage.renderAll();
      }
    },
    // 右侧章列表拖拽
    dragStart(e, s) {
      const { layerX, layerY, currentTarget: target } = e;
      e.preventDefault();
      const { width, height, offsetLeft, offsetTop } = target.querySelector("img.stamp-img");
      const { defaultWidth, defaultHeight } = s;
      // 章图的长宽比
      const ratio = defaultWidth / defaultHeight;
      const minWidth = Math.min(ratio * height, width);
      const minHeight = minWidth / ratio;
      const { drop, scale } = this;
      drop.id = s.id;
      drop.width = minWidth;
      drop.fromWidth = minWidth;
      drop.toWidth = defaultWidth * scale;
      drop.offsetX = layerX - (width - minWidth) / 2 - offsetLeft;
      drop.offsetY = layerY - (height - minHeight) / 2 - offsetTop;
      drop.x = e.pageX;
      drop.y = e.pageY;
      drop.fromX = e.pageX;
      drop.fromY = e.pageY;
      document.addEventListener("mousemove", this.dragging);
      document.addEventListener("mouseup", this.clearDrop);
    },
    dragging(e) {
      const { drop } = this;
      const maxOffset = 120;
      const x = e.pageX;
      const y = e.pageY;
      const offset = Math.max(Math.abs(drop.fromY - drop.y), Math.abs(drop.fromX - drop.x));
      const progress = Math.min(offset, maxOffset) / maxOffset;
      const width = ~~(progress * (drop.toWidth - drop.fromWidth) + drop.fromWidth);
      drop.x = x;
      drop.y = y;
      drop.width = width;
      drop.progress = progress;
      const path = e.composedPath();
      drop.on = path.indexOf(this.$refs.content) > -1;
    },
    clearDrop() {
      const { drop } = this;
      document.removeEventListener("mousemove", this.dragging);
      document.removeEventListener("mouseup", this.clearDrop);
      drop.id = undefined;
      drop.on = false;
      drop.progress = 0;
    },
    dropStamp(e) {
      const {
        scale,
        drop: { id, width, offsetX, offsetY }
      } = this;
      const s = this.stampList.find((stamp) => id === stamp.id);
      if (s) {
        this.addStamp(s, {
          width: s.defaultWidth || width,
          top: (e.offsetY - offsetY) / scale,
          left: (e.offsetX - offsetX) / scale
        });
      }
    },
    // 移除章
    async deleteStamp(s) {
      const { stage, pageStamps } = this;
      const item = this.getStampItem(s);
      const index = pageStamps.findIndex(({ id }) => id === s.id);
      item && stage.remove(item);
      if (index !== -1) pageStamps.splice(index, 1);
    }
  }
};
</script>
<style lang="scss" scoped src="./pdf.scss"></style>
